// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".t-static-field[data-v-02489b2c]{min-height:59px}", ""]);
// Exports
module.exports = exports;
